import { useQuery } from "@tanstack/react-query";
import axios from "axios";

interface Version {
  version: string;
}

const versionQueryKeys = {
  all: () => ["version"] as const,
} as const;

// 현재 버전 정보
// 프론트 public 폴더에 있는 version.json 파일을 가져오기 때문에 기본 axios를 사용
export function useVersionQuery() {
  return useQuery<Version>({
    queryKey: versionQueryKeys.all(),
    queryFn: () => axios.get("/version.json").then((res) => res.data),
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
